var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridGreenac92D5Eb4C6Bd184Ce259C7Cb0C046B9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_272_2958)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33301 0C3.0193 0 0.333008 2.68629 0.333008 6V24C0.333008 27.3137 3.0193 30 6.33301 30H24.333C27.6467 30 30.333 27.3137 30.333 24V6C30.333 2.68629 27.6467 0 24.333 0H6.33301ZM6.33301 6H24.333V24H6.33301V6ZM48.333 0C45.0193 0 42.333 2.68629 42.333 6V24C42.333 27.3137 45.0193 30 48.333 30H66.333C69.6467 30 72.333 27.3137 72.333 24V6C72.333 2.68629 69.6467 0 66.333 0H48.333ZM48.333 6H66.333V24H48.333V6ZM0.333008 48C0.333008 44.6863 3.0193 42 6.33301 42H24.333C27.6467 42 30.333 44.6863 30.333 48V66C30.333 69.3137 27.6467 72 24.333 72H6.33301C3.0193 72 0.333008 69.3137 0.333008 66V48ZM24.333 48H6.33301V66H24.333V48ZM48.333 42C45.0193 42 42.333 44.6863 42.333 48V66C42.333 69.3137 45.0193 72 48.333 72H66.333C69.6467 72 72.333 69.3137 72.333 66V48C72.333 44.6863 69.6467 42 66.333 42H48.333ZM48.333 48H66.333V66H48.333V48Z",
    fill: "#2DC8C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33301 0C3.0193 0 0.333008 2.68629 0.333008 6V24C0.333008 27.3137 3.0193 30 6.33301 30H24.333C27.6467 30 30.333 27.3137 30.333 24V6C30.333 2.68629 27.6467 0 24.333 0H6.33301ZM6.33301 6H24.333V24H6.33301V6ZM48.333 0C45.0193 0 42.333 2.68629 42.333 6V24C42.333 27.3137 45.0193 30 48.333 30H66.333C69.6467 30 72.333 27.3137 72.333 24V6C72.333 2.68629 69.6467 0 66.333 0H48.333ZM48.333 6H66.333V24H48.333V6ZM0.333008 48C0.333008 44.6863 3.0193 42 6.33301 42H24.333C27.6467 42 30.333 44.6863 30.333 48V66C30.333 69.3137 27.6467 72 24.333 72H6.33301C3.0193 72 0.333008 69.3137 0.333008 66V48ZM24.333 48H6.33301V66H24.333V48ZM48.333 42C45.0193 42 42.333 44.6863 42.333 48V66C42.333 69.3137 45.0193 72 48.333 72H66.333C69.6467 72 72.333 69.3137 72.333 66V48C72.333 44.6863 69.6467 42 66.333 42H48.333ZM48.333 48H66.333V66H48.333V48Z",
    fill: "url(#paint0_linear_272_2958)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_272_2958",
    x1: 56.4562,
    y1: -100.051,
    x2: -74.7922,
    y2: 6.37578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206376,
    stopColor: "#FFF0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359714,
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833386,
    stopColor: "#FF41F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF33FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_272_2958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridGreenac92D5Eb4C6Bd184Ce259C7Cb0C046B9);
export default __webpack_public_path__ + "static/media/grid-green.ac92d5eb4c6bd184ce259c7cb0c046b9.d44893d0e0b00b20213e428d38a7221f.svg";
export { ForwardRef as ReactComponent };